<template>
  <div class="content-container">
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-4">
            <div class="das-form-input">
              <div class="label">Khách sạn</div>
              <div class="child-w-80">
                <el-select
                  v-model="searchParams.hotelId"
                  @change="selectHotel($event)"
                >
                  <el-option
                    v-for="hotel in hotelList"
                    :key="hotel.id"
                    :value="hotel.id"
                    :label="hotel.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-col col-4">
            <div class="das-form-input">
              <div class="label"></div>
              <div class="grid-paging" style="padding: 0">
                <div class="paging">
                  <button class="btn-prev" @click="prevHotel">
                    <span class="icon" />
                  </button>
                  <button class="btn-next" @click="nextHotel">
                    <span class="icon" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :row-multi-select-with-click="true"
        @refresh="onRefresh"
        @selectionChanged="selectionChanged"
      />
    </div>

    <el-col class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteRoomLevel"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateRoomLevelView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>

      <button class="btn primary small" @click="exportExcel">
        {{ $t('button.downloadExcel') }}
      </button>
    </el-col>
    <!-- <el-col class="bottom-btns-container">
      <el-button
        type="primary"
        @click="dialogFormVisible = true"
      >Thêm hạng phòng</el-button>
      <el-button type="danger" @click="deleteRoomLevel">
        Xóa hạng phòng
      </el-button>
    </el-col> -->
    <el-dialog
      :title="!isEdit ? 'Thêm hạng phòng' : 'Sửa hạng phòng'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã hạng phòng</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã hạng phòng"
                  >
                    <input v-model="item.code" type="text" :disabled="isEdit" />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên hạng phòng</div>
                  <validation-provider
                    rules="required|max:50"
                    name="Tên hạng phòng"
                  >
                    <input v-model="item.name" type="text" />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Khách sạn</div>
                  <validation-provider rules="required" name="Khách sạn">
                    <el-select v-model="item.hotel_id">
                      <el-option
                        v-for="option in hotelList"
                        :key="option.id"
                        :value="option.id"
                        :label="option.name"
                      />
                    </el-select>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Giá thiết kế</div>
                  <validation-provider rules="number" name="Giá thiết kế">
                    <VxCurrencyInput
                      v-model="item.price"
                      :options="optionsCurrency"
                    />
                    <!-- :options="optionsCurrency" -->
                    <!-- <vue-number
                      v-model="item.price"
                      v-bind="number"
                      onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                    /> -->
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Số lượng phòng</div>
                  <validation-provider
                    rules="positiveNum|number|max_value:1000"
                    name="Số lượng phòng"
                  >
                    <input v-model="item.num_room" v-numeric-only type="text" />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Số lượng người tối đa</div>
                  <validation-provider
                    rules="positiveNum|max_value:10000"
                    name="Số lượng người tối đa"
                  >
                    <input
                      v-model="item.num_people"
                      type="number"
                      onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Số lượng thẻ miễn phí</div>
                  <validation-provider
                    rules="required|positiveNum|max_value:10000"
                    name="Số lượng thẻ miễn phí"
                  >
                    <input
                      v-model="item.free_card_quantity"
                      v-numeric-only
                      type="number"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label required">Chọn màu</div>
                  <div class="flex">
                    <validation-provider rules="required" name="Màu sắc">
                      <el-color-picker v-model="item.color"></el-color-picker>
                      <!--  -->
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateRoomLevel"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small primary outline"
            @click="addRoomLevel"
          >
            {{ $t('button.create') }}
          </button>
        </div>
        <!-- <el-button @click="dialogFormVisible = false">Huỷ</el-button>
        <el-button
          v-if="isEdit"
          type="primary"
          @click="updateRoomLevel"
        >Cập nhật</el-button>
        <el-button
          v-else
          type="primary"
          @click="addRoomLevel"
        >Tạo mới</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import CurrencyInput from '@/components/ui/currencyInput.vue'
// import { component as VueNumber } from '@coders-tm/vue-number-format'
import { CellRenderColorPicker } from '@/utils/cellRenders.js'

import {
  getListRoomLevelApi,
  updateRoomLevelApi,
  deleteRoomLevelApi,
  addRoomLevelApi,
  exportExcelApi
} from '@/api/Room/roomLevel'
import { downloadFile } from '@/utils/file-handler'
import { getAllHotel } from '@/api/hotel'
import { Message } from 'element-ui'
import { assignObjectFields } from '@/utils/form'

export default {
  components: {
    Breadcrumb,
    // VueNumber
    CurrencyInput,
    CellRenderColorPicker
  },

  data() {
    return {
      optionsCurrency: {
        currency: 'USD',
        precision: 0,
        currencyDisplay: 'hidden',
        hideGroupingSeparatorOnFocus: false,
        valueRange: {
          min: 0,
          max: 9999999999
          // max: 10
        },
        useGrouping: true
      },
      isDisableModify: false,
      isDisableDelete: false,
      hotelList: [],
      indexHotel: 0,
      titlePopup: 'Thêm mới hạng phòng',
      loading: false,
      isEdit: false,
      totalPage: 0,
      currentPage: 0,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC',
        hotelId: ''
      },
      defaultItem: {
        code: '',
        name: '',
        price: 0,
        num_people: 0,
        num_room: 0,
        hotel_id: null,
        id: null,
        color: ''
      },
      item: {
        color: '',
        code: '',
        name: '',
        price: 0,
        num_people: 0,
        num_room: 0,
        hotel_id: null,
        id: null,
        free_card_quantity: null
      },

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 50,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã hạng phòng',
          field: 'code',
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Tên hạng phòng',
          field: 'name',
          sortable: false
        },
        {
          headerName: 'Khách sạn',
          field: 'hotel_nm',
          sortable: false
        },
        {
          headerName: 'Số lượng phòng',
          field: 'num_room',
          maxWidth: 150,
          sortable: false
        },

        {
          headerName: 'Số lượng người ở tối đa',
          field: 'num_people',
          maxWidth: 180,

          sortable: false
        },
        {
          headerName: 'Giá thiết kế',
          field: 'price',
          maxWidth: 150,
          valueGetter: params => {
            if (params.data.price == null || params.data.price == undefined) {
              return null
            } else {
              return Number(params.data.price).toLocaleString('en')
            }
          },
          sortable: false
        },
        {
          headerName: 'Màu sắc',
          field: 'color',
          maxWidth: 100,
          minWidth: 100,
          cellRenderer: 'CellRenderColorPicker',
          cellRendererParams: params => {
            return {
              color: params.data.color
            }
          },
          sortable: false
          // cellClass: 'grid-cell-centered'
        }
      ],
      rows: []
    }
  },

  async mounted() {
    await this.getListHotel()
    this.searchParams.hotelId = this.hotelList?.[0].id
    await this.attachData()
  },
  methods: {
    selectHotel(value) {
      let arrayHotelId = this.hotelList.map(a => a.id)
      let indexSelected = arrayHotelId.indexOf(value)
      this.indexHotel = indexSelected
      this.searchParams.hotelId = value
      this.attachData()
    },
    async getListHotel() {
      let data = await getAllHotel()
      this.hotelList = data.data
    },
    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    prevHotel() {
      if (this.indexHotel > 0) {
        this.indexHotel -= 1
        this.searchParams.hotelId = this.hotelList[this.indexHotel]?.id
        this.attachData()
      }
    },
    nextHotel() {
      if (this.indexHotel < this.hotelList.length - 1) {
        this.indexHotel += 1
        this.searchParams.hotelId = this.hotelList[this.indexHotel]?.id
        this.attachData()
      }
    },
    validateInput() {
      // Regular expression to allow only numeric input
      this.inputValue = this.inputValue.replace(/\D/g, '')
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    updateRoomLevelView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 tòa nhà để sửa')
      } else {
        this.isEdit = true
        this.titlePopup = 'Sửa hạng phòng'
        const rowData = rowsSelected[0]
        // this.item.code = rowData.code
        // this.item.name = rowData.name
        // this.item.num_people = rowData.num_people
        // this.item.price = rowData.price
        // this.item.num_room = rowData.num_room
        // this.item.id = rowData.id
        // this.item.hotel_id = rowData.hotel_id
        // this.item.color = rowData.color
        // this.item.free_card_quantity = rowData.free_card_quantity

        this.item = assignObjectFields(rowData, [
          'code',
          'name',
          'num_people',
          'price',
          'num_room',
          'id',
          'hotel_id',
          'color',
          'free_card_quantity'
        ])
        this.dialogFormVisible = true
      }
    },
    async attachData() {
      this.loading = true
      let data = await getListRoomLevelApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addRoomLevel() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addRoomLevelApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateRoomLevel() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateRoomLevelApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    deleteRoomLevel() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$vxAlert('Bạn chưa chọn hạng phòng!')
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá hạng phòng này?', () => {
          deleteRoomLevelApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async exportExcel() {
      await exportExcelApi()
        .then(res => downloadFile(res, 'danh_sach_hang_phong.xlsx'))
        .catch(error => console.log(error))
    },

    resetItemInfo() {
      this.item = { ...this.defaultItem }
    }
  },

  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
